<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import Input from "../../../components/formComponents/Input.svelte"
    import { login, newNotification } from "../../../store"
    import { onChange } from "../../../components/formComponents/helper"
    import MagnifyableImage from "./MagnifyableImage.svelte"
    import { apiBaseURL } from "../../../../config"
    import Modal from "../../../components/Modal.svelte"
    import Cta from "../../../components/CTA.svelte"
    import SetMediaLocation from "../../inputfields/ImageUpload/SetMediaLocation.svelte"
    export let selected: boolean, image: TaskFile, media: Media
    const dispatch = createEventDispatcher()
    function deleteTaskImage() {
        if (!$login.user.roles.includes("admin")) {
            newNotification({
                class: "error",
                html: "Sie haben keine Berechtigung, um Bilder zu löschen.",
            })
            return
        }
        dispatch("remove")
    }
    let showImageFullScreen = false
    let showLocationModal = false
</script>

<div class="actionRow">
    <div class="selectedCheckbox">
        <Input
            type="checkbox"
            bind:value="{selected}"
            onChange="{onChange}"
            id="selected"
            noPadding="{true}"
        />
    </div>
    <div class="rightern">
        <button
            class="removeElement"
            on:click="{() => {
                showImageFullScreen = true
            }}"
        >
            <img
                src="../../../assets/icons/solar_full-screen-outline-white.svg"
                alt="icon"
            />
        </button>
        <button
            class="removeElement"
            on:click|preventDefault|stopPropagation="{() => {
                showLocationModal = true
            }}"
        >
            <img
                src="../../../assets/icons/solar_map-outline-white.svg"
                alt="icon"
            />
        </button>
        <button
            class="removeElement"
            on:click|preventDefault|stopPropagation="{() => {
                deleteTaskImage()
            }}"
        >
            <img
                src="../../../assets/icons/solar_close-circle-outline-white.svg"
                alt="icon"
            />
        </button>
    </div>
</div>
{#if media && showImageFullScreen}
    <Modal
        show="{showImageFullScreen}"
        on:close="{() => {
            showImageFullScreen = false
        }}"
    >
        <h3
            slot="header"
            class="label"
        >
            <img
                src="../../../assets/icons/solar_camera-outline.svg"
                alt="icon"
            />
            <p>Einsatzbild</p>
        </h3>
        <div class="modal-body">
            <MagnifyableImage
                src="{`${apiBaseURL}media/${media.id}/${media.file.src}`}"
                alt="img"
            />
            <p>Klicken Sie auf das Bild um zu zoomen.</p>
        </div>
        <div slot="footer">
            <Cta
                type="tertiaryButton"
                content="Schließen"
                icon="solar_close-circle-outline"
                on:click="{() => {
                    showImageFullScreen = false
                }}"
            />
        </div>
    </Modal>
{/if}

{#if media && showLocationModal}
    <SetMediaLocation
        bind:mediaEntry="{media}"
        on:locationSet="{() => {
            showLocationModal = false
        }}"
    />
{/if}

<style lang="less">
    @import "../../../../../assets/variables.less";
    .actionRow {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        top: 0.6rem;
        left: 0.6rem;
        right: 0.6rem;
        .selectedCheckbox {
            display: flex;
            align-items: center;
            gap: 0.6rem;
            padding: 3px;
            max-width: 30px;
            max-height: 30px;
            border-radius: 6px;
            border: 1px solid var(--grey-200);
            background: var(--white-100);
        }
        .rightern {
            display: flex;
            gap: 0.6rem;
            .removeElement {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 1.6rem;
                height: 1.6rem;
                border-radius: 48px;
                background: var(--text-100);
                img {
                    width: 1.2rem;
                    height: 1.2rem;
                }
            }
            img {
                height: 0.9rem;
                width: 0.9rem;
            }
        }
    }
</style>
